import { Modal } from 'flowbite-react';
import { useEffect, useState } from 'react';
import FormEditSupplier from '../form/FormEditSupplier';
import { useToastContext } from '../../../../common/components/ui/toast/toast.context';
import { ISupplier } from '../../../../types/supplier.types';
import { getSupplierById, updateSupplier } from '../../../../common/services/supplier.api';
import { pluck } from '../../../../common/helpers/pluck';
import Loading from '../../../../common/components/ui/loading/Loading';

type Props = {
  supplierId: string | null
  onClose: () => void
}

export default function ModalEditSupplier(props: Props) {
  const [supplierId, setSupplierId] = useState<string | null>(null)
  const { showToast } = useToastContext()
  const [supplierData, setSupplierData] = useState<ISupplier | null>(null)
  const [formRequestErrors, setFormRequestErrors] = useState([])

  const notifySuccess = (text) => showToast({ text, type: 'success' })
  const notifyError = (text) => showToast({ text, type: 'error' })

  const handleCloseModal = () => { props.onClose() }

  useEffect(() => {
    props.supplierId !== supplierId && setSupplierId(props.supplierId)
  }, [props.supplierId, supplierId])

  useEffect(() => {
    async function loadSupplierData(supplierId: string) {
      if (!supplierId) return;

      const { data, ok } = await getSupplierById(supplierId)

      if (ok) {
        setSupplierData(data as ISupplier)
      }
    }

    setSupplierData(null)

    if (supplierId) loadSupplierData(supplierId)

  }, [supplierId])


  async function saveSupplier(dataToSave: ISupplier) {
    try {
      const { ok, data, errors } = await updateSupplier(supplierId as string, dataToSave)
      if (ok && data) {
        setSupplierData(data as ISupplier)
        notifySuccess(`Fornecedor "${supplierData?.companyName}" atualizado!`)
        return { ok, data: data as ISupplier, errors: (errors as [{ message: string, path: string[] }]) }
      }
      const errorMessage = pluck('errors.0.message', { errors })
      Array.isArray(errors) && setFormRequestErrors(errors as unknown as [])
      notifyError(errorMessage)

      return { ok, data: data as ISupplier, errors: errors as [{ message: string, path: string[] }] }
    } catch (err) {
      notifyError('Erro ao tentar salvar fornecedor, tente novamente')
      return {
        ok: false,
        data: dataToSave,
        errors: [{ message: (err as Error).message, path: [] }]
      }
    }
  }

  return (
    <Modal
      size={'5xl'}
      className='relative'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black'>
        <div className="flex items-center justify-start gap-3">
          <span className='text-black'>
            {`Editando: ${(supplierData || {})?.companyName}`}
          </span>
        </div>
      </Modal.Header>
      <Modal.Body className='w-full relative border-gray flex flex-col dark:text-black' style={{ minHeight: 'calc(100vh - 300px)', height: 'calc(100vh - 300px)' }}>
        {supplierData ? (
          <FormEditSupplier onSave={(data) => (data)} onSubmit={saveSupplier} data={supplierData} formRequestErrors={formRequestErrors} />
        ) : <Loading />}
      </Modal.Body>
    </Modal>
  );
}
